import { Button, Link } from "@chakra-ui/react";
import { FaDirections } from "react-icons/fa";

type Props = {
  plannonID: string;
};

const DirectionsButton = ({ plannonID }: Props) => {
  return (
    <Button
      leftIcon={<FaDirections />}
      colorScheme="lancsBlue"
      as={Link}
      isExternal
      href={`https://use.mazemap.com/#v=1&config=lancaster&campuses=lancaster&campusid=341&desttype=identifier&dest=${plannonID}`}
    >
      Directions
    </Button>
  );
};

export default DirectionsButton;
